export default __webpack_public_path__ + "media/images/tele_vert-fa7c202f80049cc9ed489f34240627c5.png";